// import tryOutGratis from './try-out-gratis.js'
import tryOutGratis from './try-out'

const manajemenTryOut = [...tryOutGratis,]

export default manajemenTryOut
